import React, { Component } from 'react';
import InputText from "../../../../common/components/input-text/input-text";
import Select from 'react-select';
import validate from "../../../../utils/validate";
import CheckBox from "../../../../components/checkbox/checkbox";
import "../../home-navigation-panel.less";


class AddAction extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			company_id: "",
			selectCompany: null,
			error: "",
			iserror: "",
			errormessage: "",
			is_user_config: false
		}
	}

	onChangeHandler = (value, id, isType) => {
		const result = validate.validationCheck(value, this.state[id], isType);
		const errMsg = validate.legthValidation(id, value);
		this.setState({
			[id]: result,
			errormessage: errMsg
		})
	}

	handleChange = (selectCompany) => {
		this.setState({ selectCompany: selectCompany });
	}

	handleCheckboxChange = (e, id, type, user) => {
		this.setState({ is_user_config: e.target.checked });
	}

	onBlurChange = (e) => {
		let errMsg = validate.legthValidation(e.target.id, e.target.value);
		if (errMsg && e.target.value) {
			this.setState({
				iserror: e.target.id,
				errormessage: errMsg
			})
		} else if (this.state.iserror) {
			this.setState({ iserror: '' });
		}
	}

	addAction = () => {
		let paramObj = {
			"company_id": this.props.company_id,
			"name": this.state.name,
			"type": this.state.selectCompany.type,
			"is_user_config": this.state.is_user_config
		}
		let errorMsg = "";
		const validationError = {
			"Name": validate.isEmpty(paramObj.name),
		}
		const validationFields = [];
		Object.keys(validationError).forEach((key) => {
			if (validationError[key]) {
				validationFields.push(key);
			}
		});
		if (validationFields.length) {
			errorMsg = `Please Enter Valid ${validate.join(validationFields, (item, idx) => {
				if (validationFields.length === 1) {
					return "";
				}
				if (idx > 0 && idx < validationFields.length - 1) {
					return ", ";
				} else if (idx === validationFields.length - 1) {
					return " and ";
				}
				return "";
			})}.`;
		}
		let myDiv = document.getElementById('modal');
		if (errorMsg) {
			myDiv.scrollTop = 0;
			this.setState({
				error: errorMsg
			});
			return;
		}
		this.props.addAction(paramObj);
		this.props.toggleAdd2();
	}
	populateActiontypeslist = () => {
		return (
			this.props.actiontypeslist.map((company) => {
				return {
					value: company.id,
					label: company.name,
					type: company.type
				}
			}
			)
		)
	}

	render() {
		const buttonDisable = (this.state.name) ? 'add-button' : 'add-button btn-disabled';
		const options1 = this.props.actiontypeslist && this.populateActiontypeslist();
		return (
			<div className="add-user-wrap add-action-wrap-popup">
				<div onClick={this.props.toggleAdd2} className="overlay"></div>
				<div id="modal" className="modal-popup">
					<div className="pop-heading">
						Add Action
                    </div>
					<div className="content">
						<label className="error">{this.state.error}</label>
						<form className="form-section" autoComplete="nope">
							<div className="container-1" style={{ display: 'flex', flexWrap: 'wrap', gap: '18px' }}>
								<div style={{ flex: '1 1 240px', minWidth: '240px' }}>
									<div className="header">Name</div>
									<div className="sub-container">
										<InputText placeholder="Name" id={"name"} value={this.state.name} changeHandler={this.onChangeHandler} />
									</div>
								</div>
								<div style={{ flex: '1 1 240px', minWidth: '240px' }}>
									<div className="header">Type</div>
									<div className="sub-container">
										<Select className="select" value={this.state.selectCompany} onChange={this.handleChange} options={options1} />
									</div>
								</div>
								<div style={{ flex: '1 1 240px', minWidth: '240px', display: 'flex', alignItems: 'center', gap: '12px' }}>
								<div className="header" style={{ margin: 0, minWidth: 110, lineHeight: '18px' }}>User Specific</div>
								<div style={{ height: '18px' }}><CheckBox status={this.state.is_user_config} handleChange={this.handleCheckboxChange} id="is_user_config" /></div>
								</div>
							</div>
						</form>
						<div className="submit-section">
							<button className="add-button discard" onClick={this.props.toggleAdd2}>Cancel</button>
							<button className="add-button" onClick={this.addAction}>Save</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default AddAction;
